<div class="card m-3">
  <iframe
    *ngIf="externalURL"
    [src]="externalURL"
    width="100%"
    height="100%"
    frameborder="0"
    style="display: block; height: calc(100vh - 150px)"
  ></iframe>
</div>
